import { render, staticRenderFns } from "./CallsInformation.vue?vue&type=template&id=688fd8b6&"
import script from "./CallsInformation.vue?vue&type=script&lang=js&"
export * from "./CallsInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports